import { ConnectMessageType } from '@idConnect/types';
import { Maker } from './buildMachine';
import { Ctx, Snap } from './core';
import { openInIframe } from '@shared/iFrameHandler/openInIframe';
import { consoleLogger } from '@shared/logging/consoleLogger';

export const mnoSelector: Maker<Ctx, Snap, ConnectMessageType> = ({
  makeEffectGroup,
}) => [
  makeEffectGroup(
    'valid',
    (msg, { ctx, skip, pass }) => {
      if (!msg.body) {
        consoleLogger.logDebug(
          `Message body is not present. Terminating the flow...`,
        );
        return skip(`Message body is not present. Terminating the flow...`);
      }

      if (
        !Array.isArray(
          ctx.window.Utiq!.data!.clientConfig!.IDCONNECT_CONFIG
            .IDCONNECT_ALLOWED_USE_CASES,
        )
      ) {
        return skip(
          'IDCONNECT_ALLOWED_USE_CASES is not an array of strings. Terminating the flow...',
        );
      }

      if (!msg.body.useCase) {
        return skip('msg.body.useCase missing');
      }

      if (
        !ctx.window.Utiq!.data!.clientConfig!.IDCONNECT_CONFIG.IDCONNECT_ALLOWED_USE_CASES.includes(
          msg.body.useCase,
        )
      ) {
        return skip(
          `MNO Use Case ${msg.body.useCase} not defined in IDCONNECT_ALLOWED_USE_CASES. Terminating the flow...`,
        );
      }

      if (!msg.body.url) {
        return skip('No URL in message body. Terminating the flow...');
      }

      return pass(msg);
    },
    ({ makeEffect }) => [
      makeEffect(
        'updateSession',
        (msg, { ctx, pass, skip }) => {
          const idConnectMnoSelectorDomain = msg.body.url.split('/')[2] ?? null;

          if (
            ctx.state.idConnectMnoSelectorDomain !== idConnectMnoSelectorDomain
          ) {
            return pass(msg);
          }

          return skip('');
        },
        (msg, { ctx }) => {
          ctx.state.idConnectMnoSelectorDomain =
            msg.body.url.split('/')[2] ?? null;
        },
      ),

      makeEffect(
        'mspProxy',
        (msg, { pass, skip }) =>
          msg.body.useCase === 'mspProxy'
            ? pass(msg)
            : skip('msg.body.useCase', msg.body.useCase),

        (msg, { ctx }) => {
          ctx.iframeMsgs.shift();

          ctx.state.idConnectUseCase = msg.body.useCase ?? null;
          ctx.state.idConnectMnoSelectorDomain =
            msg.body.url.split('/')[2] ?? null;

          openInIframe({
            iFrameUrl: msg.body.url,
            environment: 'Utiq',
          });
        },
      ),
      makeEffect(
        'utiqCrossDomain',
        (msg, { pass, skip }) =>
          msg.body.useCase === 'utiqCrossDomain'
            ? pass(msg)
            : skip('msg.body.useCase', msg.body.useCase),

        (msg, { ctx }) => {
          ctx.iframeMsgs.shift();

          ctx.state.idConnectUseCase = msg.body.useCase ?? null;
          ctx.state.idConnectMnoSelectorDomain =
            msg.body.url.split('/')[2] ?? null;

          openInIframe({
            iFrameUrl: msg.body.url,
            environment: 'Utiq',
          });
        },
      ),

      makeEffect(
        'token',
        (msg, { pass, skip }) =>
          msg.body.useCase === 'token'
            ? pass(msg)
            : skip('msg.body.useCase', msg.body.useCase),
        (msg, { ctx }) => {
          ctx.iframeMsgs.shift();

          ctx.state.idConnectUseCase = msg.body.useCase ?? null;
          ctx.state.idConnectMnoSelectorDomain =
            msg.body.url.split('/')[2] ?? null;

          openInIframe({
            iFrameUrl: msg.body.url,
            iFrameId: 'IDENT',
            environment: 'Utiq',
          });
        },
      ),

      makeEffect(
        'saml',
        (msg, { pass, skip }) =>
          msg.body.useCase === 'saml'
            ? pass(msg)
            : skip('msg.body.useCase', msg.body.useCase),
        (msg, { ctx }) => {
          ctx.iframeMsgs.shift();

          ctx.state.idConnectUseCase = msg.body.useCase ?? null;
          ctx.state.idConnectMnoSelectorDomain =
            msg.body.url.split('/')[2] ?? null;

          openInIframe({
            iFrameUrl: msg.body.url,
            environment: 'Utiq',
          });
        },
      ),
    ],
  ),
];
